(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('nuvipil-product-help__form')) return;
    const panel = form.closest('[data-nuvipil-product-help]');
    if (!panel) return;
    const pageUrl = new URL(window.location.href);
    const productArea = panel.closest('.product-information') || document;
    const variantInput = productArea.querySelector('form[action*="/cart/add"] [name="id"]');
    const variantId = variantInput?.value || pageUrl.searchParams.get('variant');
    const referenceField = form.querySelector('[data-help-variant-id]');
    const titleField = form.querySelector('[data-help-variant-title]');
    const urlField = form.querySelector('[data-help-product-url]');
    if (!variantId || !referenceField || !titleField || !urlField) return;
    referenceField.value = variantId;
    const url = new URL(panel.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    urlField.value = url.href;
    try {
      const variants = JSON.parse(panel.querySelector('[data-help-variants]').textContent);
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (variant) titleField.value = variant.title;
    } catch { titleField.value = variantId; }
  }, true);
  const focusProductHelpStatus = () => {
    const status = document.querySelector('[data-nuvipil-product-help] [data-help-status]');
    if (status) status.focus({ preventScroll:false });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusProductHelpStatus, { once:true });
  else focusProductHelpStatus();
  } catch(e) { console.error(e); }
})();

})();
